// i18n area 'common' — locale hr-HR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.hr-HR.meta.json.
import type { enUS } from './common'

export const hrHR: typeof enUS = {
  nav: {
    home: 'Početna',
    vms: 'Virtualni strojevi',
    templates: 'Predlošci',
    importVms: 'Uvoz VM-ova',
    containers: 'Kontejneri',
    containersApps: 'Aplikacije',
    containersPods: 'Podovi',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI slike',
    containersOciRegistries: 'OCI registry',
    containersCtTemplates: 'CT predlošci',
    networkServices: 'Mrežne usluge',
    firewall: 'Vatrozid',
    checkpoints: 'Checkpointi',
    backup: 'Sigurnosne kopije',
    monitoring: 'Nadzor',
    cluster: 'Klaster',
    clusterSettings: 'Globalne postavke',
    clusterNodes: 'Čvorovi',
    clusterDevices: 'USB i PCIe resursi',
    clusterFederation: 'Federacija',
    network: 'Mreža',
    overlayNetworks: 'Overlay mreže',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Podaci',
    storages: 'Storage',
    hci: 'Hiperkonvergencija',
    ceph: 'Ceph',
    system: 'Sustav',
    tasks: 'Zadaci',
    events: 'Događaji',
    audit: 'Audit',
    diagnostics: 'Dijagnostika',
    notifications: 'Obavijesti',
    proximity: 'TVirt Proximity',
    users: 'Korisnici i grupe',
    groups: 'Grupe',
    mfa: 'MFA',
    realms: 'Realmovi i SSO',
    rbac: 'Uloge i dozvole',
    credentials: 'Vjerodajnice',
    scopes: 'Scopeovi',
    tags: 'Tagovi',
    explorer: 'Istraži',
    licensing: 'Licenca',
    information: 'Informacije'
  },
  mode: {
    light: 'Svijetla',
    dark: 'Tamna',
    system: 'Sustav',
    tooltip: 'Tema'
  },
  language: {
    tooltip: 'Jezik'
  },
  langRegion: {
    europe: 'Europa',
    northAmerica: 'Sjeverna Amerika',
    southAmerica: 'Južna Amerika',
    asia: 'Azija'
  },
  notFound: {
    title: 'Stranica nije pronađena',
    body: 'Ova adresa ne odgovara nijednoj stranici TVirta — možda se premjestila s ažuriranjem, ili je poveznica stara.',
    backHome: 'Natrag na početnu'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Cijeli klaster',
    noChildren: 'Ovdje nema pod-scopeova',
    recursive: 'Uključi potomke',
    collapse: 'Sažmi ploču scopeova',
    openPicker: 'Istraži scopeove',
    up: 'Razina više',
    countTooltip: '{direct} u ovom scopeu · {total} s potomcima'
  },
  search: {
    tooltip: 'Pretraži (⌘K)',
    placeholder: 'Pretraži VM-ove, mreže, storage…',
    empty: 'Nema rezultata',
    groups: {
      recent: 'Nedavno',
      shortcuts: 'Prečaci',
      actions: 'Radnje',
      goTo: 'Idi na'
    },
    kind: {
      catalog: 'Katalog',
      scope: 'Scope',
      node: 'Čvor'
    },
    footer: {
      navigate: 'kretanje',
      open: 'otvori',
      close: 'zatvara'
    },
    actions: {
      createVm: 'Stvori VM…',
      uploadIso: 'Prenesi ISO…',
      clusterSettings: 'Postavke klastera',
      consoleOf: 'Idi na konzolu za {name}'
    }
  },
  stub: {
    containersSummary: 'Aplikacije i sustavski kontejneri (CT), s njihovim OCI slikama, registryjima i predlošcima — upravljani uz vaše VM-ove.',
    sectionSummary_vms: 'Virtualni strojevi i njihovi predlošci — životni ciklus, snimke, migracija i konzola.',
    sectionSummary_storages: 'Storagei na kojima žive diskovi, slike i metapodaci VM-ova.',
    sectionSummary_catalogs: 'Dom datotečnih artefakata klastera: ISO slike, CT i VM predlošci te OCI arhive, organizirani u kataloge.',
    sectionSummary_overlay: 'VXLAN overlay mreže između čvorova klastera.',
    sectionSummary_fabric: 'Inventar fizičke mreže — preklopnici, portovi, LAGG-ovi i logičke mreže.',
    sectionSummary_ipam: 'Adresiranje izvedeno iz fabric i overlay mreža: tko drži svaku adresu.',
    sectionSummary_services: 'DHCP i DNS poslužitelji izvedeni iz mrežnog registra.',
    sectionSummary_ceph: 'Ceph klasteri upravljani na TVirt čvorovima.',
    sectionSummary_hci: 'Hiperkonvergentne storage tehnologije na TVirt čvorovima.',
    sectionSummary_cluster: 'Čvorovi, članstvo i postavke klastera.',
    containers: 'Sustavski kontejneri su na roadmapu — ova će ih sekcija udomiti.',
    containersApps: 'Kontejnerizirane aplikacije su na roadmapu — ovo će ih područje udomiti.',
    containersPods: 'Podovi grupiraju kontejnere koji dijele mrežu i volumene — instance su aplikacije.',
    containersCt: 'Sustavski kontejneri (CT) su na roadmapu — ovo će ih područje udomiti.',
    multiscsi: 'TVStor MultiSCSI je na roadmapu — ovo će ga područje udomiti.',
    clusterFederation: 'Federacija između TVirt klastera je na roadmapu — ovo će je područje udomiti.',
    containersOciImages: 'OCI slike su na roadmapu — ovo će ih područje udomiti.',
    containersOciRegistries: 'OCI registryji su na roadmapu — ovo će ih područje udomiti.',
    containersCtTemplates: 'CT predlošci su na roadmapu — ovo će ih područje udomiti.',
    importVms: 'Ovdje stižu ESXi i Proxmox importeri: konverzija gostiju i masovna migracija u TVirt.',
    backup: 'Integrirane sigurnosne kopije dolaze sa 6.2: deduplicirani content-addressed repozitoriji, CBT inkrementi, prozori nepromjenjivosti i replikacija repo-to-repo.',
    monitoring: 'Nadzorne ploče zagušenja na razini klastera (cpu.ready, PSI pritisak, integrirani alerti) su u dolasku — danas iste metrike žive u detaljima svakog VM-a.'
  },
  home: {
    welcome: 'Prijavljeni ste kao: {name}',
    subtitle: 'Vaš TVirt klaster na prvi pogled.',
    loadError: 'Pregled nije moguće učitati — je li TVirt backend dostupan?',
    health: {
      ok: 'Sve u redu',
      warning: 'Pozor',
      critical: 'Kritični problemi'
    },
    reason: {
      'node-down': '{subject} je isključen',
      'node-stale': '{subject} se već neko vrijeme ne javlja',
      'node-maintenance': '{subject} u održavanju',
      'tasks-failed': {
        one: '{n} neuspio zadatak u posljednja 24 sata',
        few: '{n} neuspjela zadatka u posljednja 24 sata',
        other: '{n} neuspjelih zadataka u posljednja 24 sata'
      },
      'storage-degraded': 'storage {subject} degradiran',
      'storage-error': 'storage {subject} u stanju pogreške',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store klastera nedostupan',
      'license-absent': 'nema licence — novi VM-ovi ne mogu se pokrenuti',
      'license-expired': 'licenca istekla — novi VM-ovi ne mogu se pokrenuti',
      'license-exceeded': 'prekoračeno ograničenje licence — novi VM-ovi ne mogu se pokrenuti',
      'failover-reserve-eroded': 'rezerva za failover gotovo potrošena',
      'failover-reserve-exhausted': 'rezerva za failover iscrpljena — novi VM-ovi ne mogu se pokrenuti',
      'oci-cache-nearly-full': 'OCI predmemorija gotovo puna na {subject} — digesti se izbacuju ručno',
      'oci-cache-full': 'OCI predmemorija puna na {subject} — nijedan pull neće uspjeti dok ne izbacite digeste',
      'config-replica-empty': 'replika konfiguracije na {subject} je PRAZNA — čvor nema konfiguraciju klastera dok replikacija ne uspije',
      'config-replica-stalled': 'replikacija konfiguracije na {subject} stoji — lokalna kopija zaostaje za konfiguracijom klastera'
    },
    staleChip: 'Podaci nisu ažurni',
    staleAsOf: 'posljednja replika {time}',
    zone: {
      nodes: 'Čvorovi',
      failoverReserve: 'Rezerva za failover',
      capacity: 'Kapacitet',
      workload: 'Radno opterećenje',
      protection: 'Zaštita',
      activity: 'Nedavna aktivnost'
    },
    reserve: {
      state: {
        ok: 'Rezerva netaknuta',
        eroded: 'Rezerva gotovo potrošena',
        exhausted: 'Rezerva iscrpljena',
        unknown: 'Rezerva nepoznata'
      },
      tolerate: {
        one: 'podnosi gubitak {n} čvora',
        few: 'podnosi gubitak {n} čvora',
        other: 'podnosi gubitak {n} čvorova'
      },
      usedOf: '{used} / {allowed} GiB u upotrebi',
      keepFree: '{n} GiB drži se slobodno za failover',
      expendable: 'od toga potrošivo u radu: {n}',
      headroom: 'još se može pokrenuti {n} GiB',
      short: 'rezervi nedostaje {n} GiB — novi VM-ovi ne mogu se pokrenuti',
      hp: {
        usedOf: 'Stranice od {size} — u upotrebi: {used} / {allowed}',
        keepFree: 'slobodne za failover: {keep}',
        headroom: 'još se može pokrenuti: {n}',
        short: 'nedostaje rezervi: {n} — novi VM-ovi s golemim stranicama ne mogu se pokrenuti'
      },
      worstCase: 'najgori slučaj: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Nijedan čvor još nije deklarirao memoriju — rezerva se ne može izračunati i nijedno pokretanje se ne odbija.',
      reason: {
        attestedDown: 'potvrđeno isključen',
        maintenance: 'u održavanju',
        unreachable: 'nedostupan',
        capacityUnknown: 'memorija nije deklarirana'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: 'jezgre: {cores} / niti: {threads}',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} aktivan VM',
        few: '{n} aktivna VM-a',
        other: '{n} aktivnih VM-ova'
      },
      activeVmsUnknown: 'Aktivni VM-ovi nepoznati',
      lastSeen: 'viđen {time}',
      neverSeen: 'nikad viđen',
      down: 'Isključen',
      maintenance: 'Održavanje',
      stale: 'Nedostupan'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: 'provizionirano: {n} GiB',
      reserve: 'rezerva {n} GiB',
      unobserved: 'kapacitet još nije opažen',
      empty: 'Još nema storagea'
    },
    workload: {
      vms: 'Virtualni strojevi',
      apps: 'Aplikacije',
      services: 'Mrežne usluge',
      empty: 'Još ništa',
      phasesUnknown: 'raspodjela po fazama nije dostupna'
    },
    protection: {
      none: 'Nije konfigurirano nijedno odredište backupa — zaštitite svoju konfiguraciju.',
      configure: 'Konfiguriraj checkpointe',
      noRuns: 'Još nije stvoren nijedan checkpoint.',
      last: 'Posljednji checkpoint',
      onTarget: 'na {target}',
      viewAll: 'Checkpointi'
    },
    activity: {
      empty: 'Nema nedavne aktivnosti',
      failed24: {
        one: '{n} neuspio u 24 h',
        few: '{n} neuspjela u 24 h',
        other: '{n} neuspjelih u 24 h'
      },
      viewAll: 'Prikaži sve zadatke'
    }
  },
  notes: {
    title: 'Bilješke',
    tabEdit: 'Uredi',
    tabPreview: 'Pretpregled',
    placeholder: 'Slobodne bilješke operatera — Markdown se prikazuje u pretpregledu',
    empty: 'Nema bilješki',
    tooLarge: 'Bilješke premašuju ograničenje od 64 KiB',
    saveError: 'Spremanje bilješki nije uspjelo'
  },
  common: {
    contractError: 'Odgovor backenda sadrži vrijednost koju ovo sučelje ne poznaje: {field}={value} — ažurirajte webui na verziju backenda.',
    contractErrorItems: 'Objekata na ovom popisu koje ovo sučelje ne može pročitati ({field}={value}) pa se ne prikazuju: {count}.',
    staleHint: 'Store nije dostupan — ovo je replika konfiguracije ovog čvora; stanje flote je nepoznato.',
    staleStateAge: 'stanje od {time}',
    staleStateNever: 'stanje nikad nije primljeno iz storea: vidite samo opažanja ovog čvora',
    staleStateTooltip: 'Store klastera nije dostupan: opaženo stanje (faza, čvor, agent) dolazi iz replike stanja ovog čvora i potječe iz zadnjeg uspješnog čitanja iz storea — može biti zastarjelo.',
    noPermission: 'Nemate dozvolu za ovu radnju',
    actionStillRunning: 'Radnja je još u tijeku: ishod još nije poznat',
    staleWrite: 'Netko je drugi izmijenio ovaj objekt dok ste ga uređivali — ništa nije zapisano. Ponovno učitajte i ponovite izmjenu na svježem stanju.',
    staleReload: 'Ponovno učitaj',
    preview: 'Pregled',
    previewTitle: 'Pregled rezultata',
    previewNothingWritten: 'Simulirano na poslužitelju — ništa nije zapisano.',
    previewChanged: 'Istaknute su vrijednosti koje bi se promijenile.'
  },
  context: {
    copySelection: 'Kopiraj odabrani tekst'
  },
  crud: {
    create: 'Stvori',
    viewDetails: 'Prikaži detalje',
    viewOrEdit: 'Prikaži ili uredi',
    selected: 'odabrano',
    viewUsingVms: 'Prikaži VM-ove koji koriste resurs',
    clearSelection: 'Poništi odabir',
    deleteSelected: 'Izbriši odabrano',
    bulkConfirmBody: {
      one: 'Izbrisati odabranu stavku ({count})? Ako je zaštićena, bit će označena i zadržana.',
      few: 'Izbrisati odabrane stavke ({count})? Zaštićene će biti označene i zadržane.',
      other: 'Izbrisati odabrane stavke ({count})? Zaštićene će biti označene i zadržane.'
    },
    bulkDeleted: 'izbrisano',
    bulkRefused: 'odbijeno',
    fieldId: 'ID',
    createdAt: 'Stvoreno',
    updatedAt: 'Ažurirano',
    immutableField: 'Fiksirano pri stvaranju — contract ne dopušta izmjenu',
    immutableScope: 'Scope se dodjeljuje pri stvaranju; neki se resursi premještaju namjenskom radnjom',
    observedField: 'Opaženo stanje — javlja ga platforma i ne može se mijenjati'
  }
}
